import { useDeviceType } from '@cian/ui-kit';
export function useResponsiveButtonSize() {
  var deviceType = useDeviceType();
  if (deviceType === 'phone') {
    return 'L';
  }
  return 'XS';
}